module.exports = __webpack_public_path__ + "img/028-029.529ba463.jpg";